import React, { useEffect, useRef, useState } from "react";
import "./Katbook.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { FaAtom, FaPen, FaFilm, FaClipboardList, FaPlus, FaTimes } from "react-icons/fa";
import {
  FaRegFileAlt,
  FaUserEdit,
  FaSearch,
  FaHeadphones,
  FaRegCommentDots,
  FaGlobe,
  FaChartBar,
  FaCode,
} from "react-icons/fa";
import LapLogo from '../../Assests_Url/PixelBook.png'
import student from '../../Assests_Url/student_kat.png'
import teacher from '../../Assests_Url/teacher_kat.png'
import family from '../../Assests_Url/family_kat.png'
import img1 from '../../Assests_Url/image1.png'
import img2 from '../../Assests_Url/image2.png'
import img3 from '../../Assests_Url/image3.png'
import { useLocation, useNavigate } from "react-router-dom";

const Katbook_new = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scroll === "bottom") {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  const [activeTabHeader, setActiveTabHeader] = useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const navigate = useNavigate()

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
      <div className="py-5 px-4">
        <div className="d-flex flex-column gap-4 pt-5 px-5">
          <div className="pt-2">
            <div className="text-font">
              About <span className="kat-font">KATBOOK</span>
            </div>
          </div>
          <div className="text-font1">
            A next-generation <span className="high-font">digital textbook platform</span>, developed with U-Educate to
            transform the way India learns. It blends <span className="high-font">audio, video, 2D/3D/AR/VR models, interactive
              exercises, translation tools, smart search, personalization, and analytics</span>
            into one seamless experience.
          </div>
          <div className="text-font1">
            Unlike static e-books, KATBOOK offers two tailored experiences—for Foundation learners (Classes 1–5)
            and Higher Standard learners (Classes 6–12)—ensuring every stage of education is supported with the
            right tools.
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between w-100 px-5">

          <div className="d-flex flex-column gap-3">
            <div className="compe-font">
              A Complete Digital Learning Ecosystem
            </div>
            <div className="text-font1">
              KATBOOK is not just another e-book. It is a <span className="high-font">360° learning platform</span> that combines textbooks,
              multimedia, practice tools, analytics, and teacher resources into <span className="high-font">one powerful ecosystem</span>.
            </div>
          </div>

          <div className="width65">
            <img src={LapLogo} alt="Laptop-Image" width={"100%"} />
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-2 pb-4">
          <div className="compe-font">
            Why KATBOOK ?
          </div>
          <div className="d-flex justify-content-center align-items-center gap-5">

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">
                For Students
              </div>
              <div>
                <img src={student} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It makes learning joyful,
                interactive, and self-paced
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">
                For Teachers
              </div>
              <div>
                <img src={teacher} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It provides structured lesson
                support, multimedia resources,
                and analytics
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook w-25">
              <div className="box-font">
                For Parents
              </div>
              <div>
                <img src={family} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It offers transparency into
                their child’s learning journey
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-5 pb-4">
          <div className="text-font">
            Every feature has been designed to:
          </div>
          <div className="d-flex justify-content-center align-items-center gap-5">

            <div className="d-flex flex-column align-items-center gap-3 box-feature w-25">
              <div className="px-4 pt-4">
                <img src={img1} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">Engage students</span> with joyful,
                interactive learning
              </div>
            </div>

            <div className="d-flex flex-column align-items-center gap-3 box-feature w-25">
              <div className="px-4 pt-4">
                <img src={img2} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">Empower teachers</span> with
                ready-to-use classroom tools
              </div>
            </div>

            <div className="d-flex flex-column align-items-center gap-3 box-feature w-25">
              <div className="px-4 pt-4">
                <img src={img3} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">Involve parents</span> with transparency
                and progress updates
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-5">
          <div className="compe-font">
            <span className="kat-font-kat">KATBOOK </span>Offers two tailored experiences
          </div>
          <div className="d-flex justify-content-center align-items-center gap-5 w-100">

            <div className="py-4 d-flex flex-column align-items-center gap-4 box-katOff width40">
              <div className="for-font">
                For <span className="for-foun">Foundation (Classes 1–5)</span>
              </div>
              <div className="eng-font">
                Playful, Activity-Based, Inclusive Learning.
              </div>
              <div className="d-flex align-items-center gap-2">
                <button className="button-kat" onClick={() => {
                  navigate("/katbook/uteach/foundation")
                }}>
                  UTeach KATBOOK &nbsp; &rarr;
                </button>

                <button className="button-kat" onClick={() => {
                  navigate("/katbook/ulearn/foundation")
                }}>
                  ULearn KATBOOK &nbsp; &rarr;
                </button>
              </div>
            </div>

            <div className="py-4 d-flex flex-column align-items-center gap-4 box-katOff width40">
              <div className="for-font">
                For <span className="for-foun">Higher Standards (Classes 6–12)</span>
              </div>
              <div className="eng-font">
                Advanced, Subject-Focused, Exam-Ready Learning.
              </div>
              <div className="d-flex align-items-center gap-2">
                <button className="button-kat" onClick={() => {
                  navigate("/katbook/uteach/standard")
                }}>
                  UTeach KATBOOK &nbsp; &rarr;
                </button>

                <button className="button-kat" onClick={() => {
                  navigate("/katbook/ulearn/standard")
                }}>
                  ULearn KATBOOK &nbsp; &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
    </div>
  );
};

export default Katbook_new;
